module.exports = __webpack_public_path__ + "media/images/redesign-images/contract/contract-sales-04-668d2a53be83599c479a1c54515e7adf.svg";